import { render, staticRenderFns } from "./LeaveSetupNew.vue?vue&type=template&id=59c0da6a"
import script from "./LeaveSetupNew.vue?vue&type=script&lang=js"
export * from "./LeaveSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports